import React, { useCallback, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';
import LoginCallback from '@components/LoginCallback';
import { clearCookie } from '@utils/cookieHelper';
import { AuthenticationLoader } from '@components_v2/UI/atoms/loading';

export const RequiredAuth: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();

    const storeLaunchpadUrl = useCallback(() => {
        if (!localStorage.getItem('launchpad')) {
            const queryParams = new URL(window.location.href).searchParams;
            if (queryParams.has('launchpad')) {
                const decodedUrl = decodeURIComponent(queryParams.get('launchpad') || '');
                if (decodedUrl !== '') {
                    localStorage.setItem('launchpad', decodedUrl);
                }
            }
        }
    }, []);

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            clearCookie();
            const originalUri = toRelativeUrl(window.location.href, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);

            storeLaunchpadUrl();
            oktaAuth.signInWithRedirect();
        }
        storeLaunchpadUrl();
    }, [oktaAuth, !!authState, authState?.isAuthenticated]);

    if (!authState || !authState?.isAuthenticated) {
        return <LoginCallback homePath="/" loadingElement={<AuthenticationLoader />} />;
    }

    return <Outlet />;
};
